<div class="loader">

	<div class="loader__spinner"></div>

</div>
